"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFTO781V1MissionDataMock = exports.AFTO781V1MissionDataLandingsMock = void 0;
const afto_781_v1_mission_data_model_1 = require("./afto_781_v1-mission-data.model");
class AFTO781V1MissionDataLandingsMock extends afto_781_v1_mission_data_model_1.AFTO781V1MissionDataLandings {
    constructor(data) {
        const seedData = {
            touchAndGo: 2,
            fullStop: 1,
            total: 3, // sum of touchAndGo and fullStop
        };
        super(seedData);
    }
}
exports.AFTO781V1MissionDataLandingsMock = AFTO781V1MissionDataLandingsMock;
class AFTO781V1MissionDataMock extends afto_781_v1_mission_data_model_1.AFTO781V1MissionData {
    constructor(data) {
        const seedData = {
            takeOffTime: Date.now() - 2 * 60 * 60 * 1000,
            landTime: Date.now(),
            landings: new AFTO781V1MissionDataLandingsMock(),
            specialUse: 1,
        };
        super(seedData);
    }
}
exports.AFTO781V1MissionDataMock = AFTO781V1MissionDataMock;
